<div class="me-login" *ngIf="data">
    <div class="klenico-me__background">
        <div class="klenico-me__background__inner"></div>
    </div>
    <div class="container">
        <div class="me-login-background">
            <div class="me-login-background__title">
                {{data.title}}
            </div>
            <div class="me-login-background__register">
                {{data.dontHaveAccountText}}
                <a [routerLink]="['/me/register']">{{data.registerText}}</a>
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                <span class="fas fa-exclamation-circle" aria-hidden="true"></span>{{ errorMessage | translate }}
            </div>
            <form [formGroup]="form" novalidate class="mat-form" (keydown)="keyDownFunction($event)">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <div class="me-form-input-group">
                            <div class="me-form-input" [class.error]="!(form.controls.email.valid
                            || (form.controls.email.pristine && !submitted))">
                                <label class="me-form-input__label">{{ 'Email Address' | translate }}*</label>
                                <input formControlName="email" class="me-form-input__input" />
                            </div>
                            <small [hidden]="form.controls.email.valid
                                                || (form.controls.email.pristine && !submitted)"
                                        class="me-form-input__error">
                                    {{ 'The email is not valid' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="me-form-input-group">
                            <div class="me-form-input" [class.error]="!(form.controls.password.valid
                            || (form.controls.password.pristine && !submitted))">
                                <label class="me-form-input__label">{{ 'Password' | translate }}*</label>
                                <input formControlName="password" class="me-form-input__input" [attr.type]="hidePassword ? 'password' : 'text'" />
                                <div class="show-password" (click)="hidePassword = !hidePassword">
                                    <i class="far fa-eye" *ngIf="hidePassword"></i>
                                    <i class="far fa-eye-slash" *ngIf="!hidePassword"></i>
                                </div>
                            </div>
                            <small [hidden]="form.controls.password.valid
                                                || (form.controls.password.pristine && !submitted)"
                                        class="me-form-input__error">
                                    {{ 'Password is required.' | translate }}
                            </small>
                        </div>
                    </div>
                </div>
            </form>
            <div class="me-login-background__forgot">
                <a [routerLink]="['/me/forgot-password']">{{data.passwordForgottenText}}</a>
            </div>
            <div class="me-login-background__login">
                <button type="submit" class="btn btn--primary me-login-background__login__button" [class.disabled]="!form.valid" (click)="login(form.value, form.valid)">{{ 'Login' | translate }}</button>
            </div>
        </div>
    </div>
</div>